import { render } from "./Menu.vue?vue&type=template&id=fc977cb4"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=fc977cb4&lang=css"
script.render = render

export default script